import { useState } from "react";
import { Get, Set } from "../../../../../Request";

export const useReportSingle = () => {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState();
  const getData = async data => {
    setLoading(true);
    Get({
      url: "/report_bug/admin_single",
      data: { ...data },
    }).then(response => {
      setData(response);
      setLoading(false);
    });
  };
  return {
    getData,
    loading,
    data,
  };
};
